import { css } from '@emotion/css';
import { m, mobileMediaQuery } from '@snapchat/snap-design-system-marketing';

export const fabButtonCss = css`
  backdrop-filter: blur(4px);
  background: ${m('--neutral-v700')};
  border-radius: ${m('--spacing-xxxxl')} ${m('--spacing-xxxxl')} 0 ${m('--spacing-xxxxl')};
  bottom: max(
    calc(${m('--spacing-m')} + 70px),
    10vh
  ); /* 70px is the mobile persistent CTA height */
  color: ${m('--neutral-v0')};
  height: ${m('--spacing-xxxxl')};
  opacity: 0.7;
  position: fixed;
  right: 5vw;
  width: ${m('--spacing-xxxxl')};

  .icon {
    height: ${m('--spacing-xxxxl')};
    opacity: 1;
    width: ${m('--spacing-xxxxl')};
  }

  &:hover {
    background: ${m('--neutral-v700')};
    border-color: transparent;
    transform: none;
  }
`;

export const panelContainerCss = css`
  background: ${m('--neutral-v0')};
  border-radius: ${m('--border-radius-l')};
  bottom: 10vh;
  box-shadow: ${m('--box-shadow-xl')};
  color: ${m('--neutral-v700')};
  display: flex;
  flex-direction: column;
  height: 641px;
  isolation: isolate;
  overflow: hidden;
  position: fixed;
  right: 5vw;
  width: 375px;

  ${mobileMediaQuery} {
    border-radius: 0;
    height: 100vh;
    height: 100dvh;
    bottom: 0;
    right: 0;
    width: 100%;
  }
`;

export const panelHeaderCss = css`
  align-items: flex-end;
  background: ${m('--neutral-v0')};
  display: flex;
  flex-direction: column;
  padding: ${m('--spacing-m')};
  z-index: 2;
`;

export const minimizeButtonCss = css`
  background-color: transparent;
  border: none;
  box-shadow: none;
  transition: none;

  &:hover,
  &:active,
  &.active {
    background-color: transparent;
    border: none;
    box-shadow: none;
    transform: none;
  }
`;

export const panelBodyCss = css`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  z-index: 1;
`;

export const welcomeContainerCss = css`
  align-items: center;
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  justify-content: center;
  min-height: 0;
  min-width: 0;
  padding: 0 ${m('--spacing-xl')};
`;

export const welcomeTitleCss = css`
  color: ${m('--neutral-v700')};
  font-family: ${m('--font-family')};
  font-size: ${m('--h4-desktop-font-size')};
  font-weight: 500;
  line-height: 1.2;
  white-space: pre-wrap;
  width: 100%;
`;

export const conversationAreaCss = css`
  align-items: stretch;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain; /* prevents scroll from leaking to the page */
  padding: 0 ${m('--spacing-m')};

  & > *:first-child {
    margin-top: auto;
  }
`;

export const suggestionsContainerCss = css`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: ${m('--spacing-xs')};
  justify-content: flex-end;
  padding: ${m('--spacing-m')} 0;
  width: 100%;
`;

export const suggestionChipCss = css`
  && {
    background: ${m('--neutral-v150')};
  }
`;

export const disclaimerContainerCss = css`
  padding: 0 ${m('--spacing-m')};
  width: 100%;

  p {
    color: ${m('--neutral-v400')};
    font-size: ${m('--p3-mobile-font-size')};
    font-weight: ${m('--p3-mobile-font-weight')};
    line-height: ${m('--p3-mobile-font-line-height')};
    margin: 0;
    text-align: center;
  }

  a {
    color: ${m('--neutral-v400')};
    display: block;
    text-decoration: underline;
  }
`;

export const bottomSafeCss = css`
  flex-shrink: 0;
  height: ${m('--spacing-l')};
  width: 100%;
`;
